/**
 * Prefix constant used when creating admin modal action creators.
 */
export const ADMIN_MODALS_HISTORY_ACTION_TYPE_PREFIX = 'admin_modals/history/';
